import React from "react";
import svg85 from "../../assets/svg/svg85.svg";

function BgHeader({ title, invst }) {
  return (
    <div className="irigInfo-pic pt-[6rem] pb-[3rem] lg:mt-[7.4rem] mt-[3rem] lg:px-0 px-3 flex flex-col lg:items-center lg:justify-center">
      <div className="text-[#050505] font-[600] font-sora lg:text-[2.25rem] text-[1.25rem]">
        {title}
      </div>
      {invst && (
        <>
          {" "}
          <div className="mt-[.5rem] text-[#1A1A1A] font-[400] leading-[1.5rem] lg:text-[1.125rem] text-[1rem] font-sora">
            National Irrigation Support and Improvement Programme
          </div>
          <div className="mt-[1rem]">
            <img src={svg85} alt="svg85" />
          </div>
        </>
      )}
    </div>
  );
}

export default BgHeader;
